import { useEffect } from 'react';

import { useSetAtom } from 'jotai';
import { UseFormReturn, useWatch } from 'react-hook-form';

import { userLocaleAtom } from '@store';

import { UserSettingsForm } from './UserSettings';

export const useSetLocaleAtom = (form: UseFormReturn<UserSettingsForm>) => {
    const locale = useWatch({
        control: form.control,
        name: 'locale',
    });

    const set = useSetAtom(userLocaleAtom);

    useEffect(() => {
        set(locale);
    }, [locale]);
};
